class DOTDMenu{
	constructor(){
		this.menuWrapper = document.getElementById("menuWrapper");
		this.mobileBtn = document.getElementById("menuTrigger");
		this.menuItems = document.querySelector(".menuItems");
		this.closeMobileBtn = document.getElementById("closeMobileMenu");
		this.lastMenuItem = document.getElementById("suggestDeal");
		
		this.suggestPromise = null; 
		this.rulesPromise = null;
		//this.pwaPromise = null;
		//this.pushNotifyJS = null;
		//this.pushPromise = null; 

		this.events = this.events.bind(this);
		this.closeOnEscape = this.closeOnEscape.bind(this);
		this.trapFocus = this.trapFocus.bind(this);
		this.onResize = this.onResize.bind(this);
	}
	
	async init(){
		this.menuWrapper.addEventListener("click", this.events);
		window.addEventListener("resize", this.onResize);

		// if we are on the homepage, then initialize push notifications
		// commenting out for now but keeping in case we want to reference it in the future
		/*if(document.querySelector(".dotdMain")){
			this.pushNotifyJS = await this.loadPushNotifications();
			if(this.pushNotifyJS) this.pushNotifyJS.init();
		} */
	}

	async events(e){
		const target = e.target;
		if(target.id === "menuTrigger"){
			e.preventDefault();
			this.toggleMenu();
		}else if(target.id === "suggestDeal"){
			e.preventDefault();
			const suggestDialog = await this.loadSuggestDialog();
        	if(suggestDialog) suggestDialog.open(e, target);
		}else if(target.id === "closeMobileMenu"){
			e.preventDefault();
			this.closeMenu();
		}else if(target.id === "rulesRegs"){
			e.preventDefault();
			const rulesDialog = await this.loadRulesDialog();
        	if(rulesDialog) rulesDialog.open(e, target);
		}
		/*else if(target.id === "alertMe"){
			e.preventDefault();
			const pushNotifyDialog = await this.loadPushNotifyDialog();
        	if(pushNotifyDialog) pushNotifyDialog.open(e, target, this.pushNotifyJS);
		}*/
	}

	onResize(){
		if(window.innerWidth <= 801 && window.innerWidth > 795 && !this.menuItems.classList.contains("hide")){
			this.menuItems.classList.add("hide");
			setTimeout(() => {
				this.menuItems.classList.remove("hide");
			}, 200);
		}
	}

	toggleMenu(){		
		if (this.mobileBtn.getAttribute("aria-expanded") == "true") this.closeMenu();
		else this.openMenu();
	}

	openMenu(){
		this.mobileBtn.setAttribute("aria-expanded", "true");
		this.menuItems.classList.add("is-active");
		document.addEventListener("keyup", this.closeOnEscape);
		this.lastMenuItem.addEventListener("keydown", this.trapFocus);
		setTimeout(() =>{
			this.closeMobileBtn.focus();
		}, 200);	
	}
	
	closeMenu(){
		this.mobileBtn.setAttribute("aria-expanded", "false");
		this.menuItems.classList.remove("is-active");
		this.mobileBtn.focus();
		document.removeEventListener("keyup", this.closeOnEscape);
		this.lastMenuItem.removeEventListener("keydown", this.trapFocus);
	}

	closeOnEscape(e){
		if(e.key === "Escape") this.closeMenu();
	}

	trapFocus(e) {
        if (e.keyCode === 9 && e.shiftKey) {
            e.preventDefault();
            e.stopPropagation();
            const link = e.currentTarget.parentNode.previousElementSibling;
            const previousLink = link.querySelector("a") ? link.querySelector("a") : link.querySelector("button");
            previousLink.focus();
        } else if (e.keyCode === 9) {
            e.preventDefault();
            e.stopPropagation();
            this.closeMobileBtn.focus();
        }
    }

	async loadSuggestDialog() {
		if(this.suggestPromise){ return this.suggestPromise.default; }
		try {
			this.suggestPromise = await import('../dialogs/suggest.js');
			this.suggestPromise.default.init(); // Call init if needed
			return this.suggestPromise.default; // Return the default export
		} catch (error) {
			console.error("Error in loadSuggestDialog. Failed to load your module:", error);
			this.suggestPromise = null; // Reset to allow retry on failure
			return null;
		}
	}

	async loadRulesDialog() {
		if(this.rulesPromise){ return this.rulesPromise.default; }
		try {
			this.rulesPromise = await import('../dialogs/rules.js');
			this.rulesPromise.default.init(); // Call init if needed
			return this.rulesPromise.default; // Return the default export
		} catch (error) {
			console.error("Error in loadRulesDialog. Failed to load your module:", error);
			this.rulesPromise = null; // Reset to allow retry on failure
			return null;
		}
	}

	// no longer using push notifications
	// commenting out for now but keeping in case we want to reference it in the future

	/*async loadPushNotifyDialog() {
		if(this.pushPromise){ return this.pushPromise.default; }
		try {
			this.pushPromise = await import('../../pushnotifications/pushnotifydialog.js');
			this.pushPromise.default.init();
			return this.pushPromise.default; // Return the default export
		} catch (error) {
			console.error("Error in loadPushNotifyDialog. Failed to load your module:", error);
			this.pushPromise = null; // Reset to allow retry on failure
			return null;
		}
	}*/

	/*async loadPushNotifications(){
		 if(this.pwaPromise){ return this.pwaPromise.default; }
		 try {
			 this.pwaPromise = await import('../../pushnotifications/serviceworker.js');
			 return this.pwaPromise.default; // Return the default export
		 } catch (error) {
			 console.error("Error in loadPushNotifications. Failed to load your module:", error);
			 this.pwaPromise = null; // Reset to allow retry on failure
			 return null;
		 }
	}*/
}

export default new DOTDMenu();